import React ,{useEffect, useState} from 'react';
import styled from "styled-components";
import { NavLink } from 'react-router-dom';
import { cerrarSesionAccion } from '../../../redux/usuarioDucks'
import { useSelector, useDispatch} from 'react-redux'
const NavbarWrapper = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #f9f9f9;
  position: fixed;
  top: 8vh;
  right: ${props => (props.open ? "0" : "-100%")};
  width: 100%;
  height: 90vh;
  transition: right 0.3s linear;
  .navlinkbar{
    border-bottom: 1px solid rgba(34,36,38,.15);
    width: 90%;
  }

  @media only screen and (min-width: 780px) {
    flex-direction: row;
    position: initial;
    height: auto;
    justify-content: flex-end;
    background: transparent;
    :hover{
      color: #19C1B6;
    }
    :active{
      color: #19C1B6;
    }
    .navlinkbar{
      border:none;
      width:auto;

    }
    
  }

  a {
    padding: 0.5rem 0.8rem;
    color: #212529;
    text-decoration: none;
    font-weight: 700;
    font-size: 1rem
    :hover{
      color: #19C1B6;
    }
    :focus{
      color: #19C1B6;
    }
    :active{
      color: #19C1B6;
    }
    .navlinkbar{
      border-top: 1px solid rgba(34,36,38,.15);
    }
  }
`;

function Navbar ({ open, handleClick , props }) {
  const activo = useSelector(store => store.usuario.activo)

  const dispatch = useDispatch()
  const cerrarSesion = (props) => {
    //console.log(props)
  //    props.history.push('/')
      dispatch(cerrarSesionAccion())
     
  }

   return (
    <NavbarWrapper open={open}>
    <div  className="navlinkbar">
    <a className="btn" href="https://bicci.cl/"  >Home</a>
    </div>
    <div  className="navlinkbar">
    <NavLink className="btn " onClick={handleClick}  to="/inicio" exact>Inicio</NavLink>
    </div>
    <div  className="navlinkbar">
    <NavLink className="btn " onClick={handleClick} to="/nosotros" exact>Nosotros</NavLink>
    </div>
    <div  className="navlinkbar">
    <NavLink className="btn " onClick={handleClick} to="/servicios" exact>Servicios</NavLink>  
    </div>
    {/* 
    <div  className="navlinkbar">
    <NavLink className="btn " onClick={handleClick}  to="/consulta-envio" exact>Consulta tu envío</NavLink> 
    </div>
     */}

    <div  className="navlinkbar">
    <NavLink className="btn " onClick={handleClick} to="/contacto" exact>Contacto</NavLink> 
    </div>
    {
        activo?(  <div  className="navlinkbar">
        <NavLink className="btn  mr-2" onClick={handleClick} to="/mi-cuenta" exact><i className="user circle icon"></i>Perfil</NavLink>
        </div> ):(<></>)
      }
      {
      activo?(  <div  className="navlinkbar">
      <NavLink className="btn mr-2 " onClick={() => cerrarSesion(props)} to="/login" ><i className="sign out alternate icon koFoOQ"></i>Salir</NavLink>
      </div> 
      ):(<div  className="navlinkbar">
      <NavLink className="btn " onClick={handleClick} to="/login" exact>Login</NavLink>
      </div>)
      }
   
  
  


    </NavbarWrapper>
  );
};

export default Navbar;
